import React, { useEffect, useState, useLayoutEffect} from "react";
import "./generalReports.css";
import FilterBox from "../../Components/filterBox/filterBox";
import Api from "../../services/api";
import TableList from "../../Components/tableList/TableList";
import MessageTable from "../../Components/messageTable/MessageTable";
import InputReport from "../../Components/inputReport/inputReport";
import DatePicker from "../../Components/datePicker/datePicker";
import Button from '../../Components/commonButton/commonButton';
import Spinner from "react-bootstrap/Spinner";
import styles from "../General/details.module.css";
import Select from '../../Components/select/select'
import moment from "moment";
import "./generalReports.css";
import api from "../../services/api";
import ExportExcelButton from "../../Components/exportExcelButton/ExportExcelButton";

const ReportOeeWorkShift = () => {

  const [dataFilter, setDataFilter] = useState([]);
  const [control,setControl] = useState([1]);
  const [loading, setLoading] = useState(true);
  const [machines, setMachines] = useState([]);
  const [workShifts, setWorkShifts] = useState([]);
  const [machine, setMachine] = useState(null);
  const [workShift, setWorkShift] = useState(null);
  const [date, setDate] = useState(moment().format("YYYY-MM-DD").toString());

    useEffect(() => {
        function firstLoad() {
            
          Api.get("/work-shifts/")
            .then((response) => {

            let array = [{label: "Todos", value: "null"}];
              
            response.data.forEach((element) => {
              array.push({
                label: element.code,
                value: element.id
              });
              
            });
            if (array.length > 0) {
              //Se a quantidade de dados for maior que zero ele salva os dados nos seguintes states: data e dataFilter. Depois ele desabilita a tela de loading.
                setWorkShifts(array);
            };
           
          })
          .catch((err) => {
            alert(err);
          });  

          Api.get("/machines/")
            .then((response) => {

            let array = [{label: "Todas", value: "null"}];
              
            response.data.forEach((element) => {
              array.push({
                label:`${element.description}${element.code}`,
                value: element.id
              });
              
            });
            if (array.length > 0) {
              //Se a quantidade de dados for maior que zero ele salva os dados nos seguintes states: data e dataFilter. Depois ele desabilita a tela de loading.
                setMachines(array);
            };
           
          })
          .catch((err) => {
            alert(err);
          });  
        }

        firstLoad();
        
    },[])

    const selectMachine = (value)=>{
      setMachine(value);
    }

    const selectWorkshift = (value)=>{
      setWorkShift(value);
    }

    const saveDate = (value)=>{
      if(value != "Invalid date"){
        setDate(moment(value, "DD/MM/YYYY").format("YYYY-MM-DD").toString());
      }else{
        setDate(null)
      }
      
    }

    const button = () => {
      setLoading(true);
      setDataFilter([]);
      setControl([...[1]])
    } 

    // Essa função é executada quando clicamos em um botão.

    useEffect(()=>{

      if(machine != null || workShift != null || date != null){
        api.get(`/reports/oee-work-shift/?machine=${machine}&work_shift=${workShift}&date=${date}`).then((response)=>{
          if(response.data.length > 0){
            let aux = [];
            response.data.forEach((element)=>{
              aux.push({
                "Máquina": element.machine,
                Turno: element.work_shift,
                Data: moment(element.appointment_date).format("DD/MM/YYYY"),
                OEE: `${element.oee}%`,
                Performance: `${element.performance}%`,
                Disponibilidade: `${element.disponibility}%`,
                Qualidade: `${element.quality}%`
              })
            })
            
            setDataFilter(aux);
          }else{
            setDataFilter([])
          }
        }).catch((error)=>{
          console.log(error);
        })
      }else{
        console.log("Nenhum filtro foi selecionado!");
      }

      setLoading(false);
    },[control])

    
    return(
      <div className="filters boxReport">
      <FilterBox title="Filtros">
        <div className="elementFilter" type="input">
            <Select label="Máquina" arrData={machines} handleSelect={selectMachine}></Select>
        </div>
        <div className="elementFilter" type="input">
          <Select label="Turno" arrData={workShifts} handleSelect={selectWorkshift}></Select>
        </div>
        <div className="elementFilter" type="input">
          <DatePicker label="Data" name="date" title="Data" parentCallback={saveDate}></DatePicker>
        </div>
        <div className="buttonFilter" type="button">
                <ExportExcelButton
                  data={dataFilter}
                  filename={`oee_turno_${moment()
                    .utc()
                    .utcOffset("-03:00")
                    .format("DDMMYY_HHmmss")}.csv`}
                />
              </div>
        <div className="buttonFilter" type="button">
            <Button size title="Gerar" icon="faGear" parentCallback={button}/>
        </div>
      </FilterBox>
      <div className="TableReport" id="tabela">
      {loading ? (
        
        <div style={{ marginTop: '20vh' }} className={styles.loader}>
          <Spinner variant="success" animation="border" />
          <strong>Carregando...</strong>
        </div>         
    ) : (
      <>
        {dataFilter.length > 0 ? (

            <TableList data={dataFilter}></TableList>
            
        ) : (

            <MessageTable message={"Sem dados para processar."} />

        )}
        </>
    )}
       </div>
    </div>
    );
};

export default ReportOeeWorkShift;